module.exports = __webpack_public_path__ + "img/Roçadeira automática.cb0be2a8.webp";